module.exports = __webpack_public_path__ + "assets/img/s5-subtitle-2-42e6515b.png";